<template>
  <div class="view-page-wrap">
    <div class="view-page">
      <div class="left">
        <div class="module-name" :class="'module-name-' + classifyId">
          <div class="text">
            <div class="name" v-if="classifyId === 1">知图甄选</div>
            <div class="name" v-else-if="classifyId === 2">国内图情</div>
            <div class="name" v-else-if="classifyId === 3">海外图情</div>
            <div class="name" v-else-if="classifyId === 4">知图社区</div>
            <div class="desc" v-if="classifyId === 1">
              甄选优秀作者的优质文章
            </div>
            <div class="desc" v-else-if="classifyId === 2">
              追踪国内行业最热最新
            </div>
            <div class="desc" v-else-if="classifyId === 3">
              聚焦国际图情发展前沿
            </div>
            <div class="desc" v-else-if="classifyId === 4">
              开放共享图情社区
            </div>
          </div>
        </div>
        <div class="list">
          <sort
            :sortType="sortType"
            :chagneSortType="chagneSortType"
            :list="sortList"
          />
          <div class="split-line"></div>
          <div v-if="loading">
            <a-skeleton active />
            <a-skeleton active />
            <a-skeleton active />
            <a-skeleton active />
            <a-skeleton active />
            <a-skeleton active />
            <a-skeleton active />
            <a-skeleton active />
            <a-skeleton active />
            <a-skeleton active />
          </div>

          <div v-else>
            <div
              class="article-item"
              v-for="item in articleList"
              :key="item.essayId"
            >
              <div class="title">
                <router-link
                  :to="{ path: '/view/detail', query: { id: item.essayId } }"
                  target="_blank"
                  >{{ item.title }}</router-link
                >
              </div>
              <div class="pic f-r" v-if="item.imgUrl">
                <router-link
                  :to="{ path: '/view/detail', query: { id: item.essayId } }"
                  target="_blank"
                >
                  <img
                    :src="
                      item.imgUrl.indexOf('https://') === -1
                        ? imgSiteUrl + item.imgUrl
                        : item.imgUrl
                    "
                    alt=""
                  />
                </router-link>
              </div>
              <router-link
                :to="{ path: '/view/detail', query: { id: item.essayId } }"
                target="_blank"
              >
                <div class="desc" v-html="item.summary"></div>
                <div class="topics" v-if="item.topicList" :class="'topics'+item.topicList.length">
                  <span v-for="i in item.topicList" :key="i.topicId">
                    <router-link
                      :to="{ path: '/view/topic', query: { id: i.topicId } }"
                      target="_blank"
                      >{{ i.topicName }}</router-link
                    >
                  </span>
                  <!-- <a href="javascript:;" v-for="i in item.topicList" :key="i.topicId">{{i.topicName}}</a> -->
                </div>
              </router-link>
              <div class="user-ctrls">
                <div class="teacher f-l">
                  <span class="date f-r"><i>·</i>{{ item.pubTime }}</span>
                  <div class="teacher-info f-l">
                    <div class="teacher-header">
                      <router-link
                        :to="{ path: '/user', query: { id: item.userId } }"
                        target="_blank"
                      >
                        <img
                          v-if="item.uImg"
                          :src="imgSiteUrl + item.uImg"
                          alt=""
                        />
                        <img v-else src="~@/assets/img/head1.png" alt="" />
                      </router-link>
                    </div>
                  </div>
                  <div class="tearcher-name f-l">
                    <router-link
                      :to="{ path: '/user', query: { id: item.userId } }"
                      target="_blank"
                      >{{ item.userName }}</router-link
                    >
                  </div>
                </div>
                <div class="article-attr-wrap f-r">
                  <div class="article-attrs">
                    <span class="browseCount"
                      ><i class="iconfont icon-liulan"></i>&nbsp;{{
                        numWan(item.browseQua)
                      }}&nbsp;</span
                    >
                    <span class="collectCount"
                      ><i class="iconfont icon-shoucang"></i>&nbsp;{{
                        numWan(item.collectQua)
                      }}&nbsp;</span
                    >
                    <span class="recCount"
                      ><i class="iconfont icon-dianzan_kuai"></i>&nbsp;{{
                        numWan(item.praiseQua)
                      }}&nbsp;</span
                    >
                    <span class="recCount"
                      ><i class="iconfont icon-pinglun"></i>&nbsp;{{
                        numWan(item.commentQua)
                      }}&nbsp;</span
                    >
                  </div>
                </div>
                <div class="clear"></div>
              </div>
            </div>
            <div class="page" v-if="page.allPage && page.allPage > 1">
              <a-pagination
                v-model:current="page.pageNum"
                :total="page.allSize"
                :show-total="(total) => `共 ${page.allSize} 篇`"
                :page-size="10"
                show-quick-jumper
                @change="changePage"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <hot-topics />
        <div class="hot-tabs">
          <a-tabs v-model:activeKey="activeKey" :animated="false">
            <a-tab-pane key="1" tab="热门文章">
              <div class="list">
                <div
                  class="item"
                  v-for="(item, key) in hotEssayList"
                  :key="item.essayId"
                >
                  <div class="sort" :class="'sort-' + key">{{ key + 1 }}</div>
                  <div class="title">
                    <router-link
                      target="_blank"
                      :to="{
                        path: '/view/detail',
                        query: { id: item.essayId },
                      }"
                      >{{ item.title }}</router-link
                    >
                  </div>
                  <div class="time">{{ item.pubTime }}</div>
                </div>
              </div>
            </a-tab-pane>
            <a-tab-pane key="2" tab="热门资讯">
              <div class="list">
                <div
                  class="item"
                  v-for="(item, key) in hotNewsList"
                  :key="item.essayId"
                >
                  <div class="sort" :class="'sort-' + key">{{ key + 1 }}</div>
                  <div class="title">
                    <router-link
                      target="_blank"
                      :to="{
                        path: '/view/detail',
                        query: { id: item.essayId },
                      }"
                      >{{ item.title }}</router-link
                    >
                  </div>
                  <div class="time">{{ item.pubTime }}</div>
                </div>
              </div>
            </a-tab-pane>
            <a-tab-pane key="3" tab="热门帖子">
              <div class="list">
                <div
                  class="item"
                  v-for="(item, key) in hotBssList"
                  :key="item.essayId"
                >
                  <div class="sort" :class="'sort-' + key">{{ key + 1 }}</div>
                  <div class="title">
                    <router-link
                      target="_blank"
                      :to="{
                        path: '/view/detail',
                        query: { id: item.essayId },
                      }"
                      >{{ item.title }}</router-link
                    >
                  </div>
                  <div class="time">{{ item.pubTime }}</div>
                </div>
              </div>
            </a-tab-pane>
          </a-tabs>
        </div>
        <author-rec :title-border="true" />
      </div>
      <div class="clear"></div>
    </div>
  </div>
</template>

<script>
import {
  computed,
  defineComponent,
  onMounted,
  reactive,
  toRefs,
  watchEffect,
} from "vue";
import config from "../../until/configs";
import Http from "../../until/http";
import HotTopics from "../../components/HotTopics.vue";
import AuthorRec from "../../components/AuthorRec.vue";
import { useRoute, useRouter } from "vue-router";
import Sort from "../../components/Sort.vue";
import { numWan } from "../../until/tools";
export default defineComponent({
  components: { HotTopics, AuthorRec, Sort },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const classifyId = computed(() => {
      let id = route.query.classifyId;
      if (id) {
        return parseInt(id);
      } else {
        return 1;
      }
    });

    const sortType = computed(() => {
      let type = route.query.sortType;
      if (type) {
        return parseInt(type);
      } else {
        return 1;
      }
    });
    const cp = computed(() => {
      let p = route.query.cp;
      if (p) {
        return parseInt(p);
      } else {
        return 1;
      }
    });

    const state = reactive({
      imgSiteUrl: config.imgSiteUrl,
      page: {},
      articleList: [],
      loading: false,
      activeKey: "1",
      hotEssayList: [],
      hotNewsList: [],
      hotBssList: [],
      sortList: [
        { value: 1, title: "最近更新" },
        { value: 2, title: "浏览最多" },
      ],
    });

    const getArticleList = () => {
      state.loading = true;
      Http.getViewList({
        sortType: sortType.value,
        pageNum: cp.value,
        classifyType: classifyId.value,
      }).then((res) => {
        state.loading = false;
        if (res.essayList) {
          res.page.pageNum = cp.value;
          Object.assign(state, {
            page: res.page,
            articleList: res.essayList,
          });
          window.scrollTo(0, 0);
        }
      });
    };

    const changePage = (num) => {
      router.push({
        path: "/view",
        query: {
          classifyId: classifyId.value,
          sortType: sortType.value,
          cp: num,
        },
      });
    };

    const chagneSortType = (e) => {
      router.push({
        path: "/view",
        query: { classifyId: classifyId.value, sortType: e },
      });
    };

    watchEffect(() => {
      getArticleList();
    });

    onMounted(() => {
      getArticleList();
      document.title = "图情视界-" + config.siteTitle;
      Http.getHotArticles({ type: 1 }).then((res) => {
        if (res.hotEssayList) {
          Object.assign(state, {
            hotEssayList: res.hotEssayList,
          });
        }
      });
      Http.getHotArticles({ type: 2 }).then((res) => {
        if (res.hotEssayList) {
          Object.assign(state, {
            hotNewsList: res.hotEssayList,
          });
        }
      });
      Http.getHotArticles({ type: 3 }).then((res) => {
        if (res.hotEssayList) {
          Object.assign(state, {
            hotBssList: res.hotEssayList,
          });
        }
      });
    });

    return {
      classifyId,
      sortType,
      cp,
      changePage,
      chagneSortType,
      ...toRefs(state),
      numWan,
    };
  },
});
</script>
<style lang="scss">
#app {
  .hot-tabs {
    .ant-tabs-nav {
      padding: 0 15px;
      .ant-tabs-tab {
        margin-right: 20px;
        font-size:16px;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
@import "../../scss/view.scss";
.header-side{
  padding:none
}
</style>>